import { logEvent } from "firebase/analytics";
import { addDoc, collection, deleteDoc, doc, DocumentReference, FieldPath, getDoc, onSnapshot, query, setDoc, Timestamp, where, documentId, orderBy, updateDoc } from "firebase/firestore";
import moment from "moment";
import React, { useContext, useEffect, useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Button } from "./Button";
import { FirebaseContext } from "./context";
import { capitalizeFirstLetter } from "./funcs";
import { FirestoreConverter, IComment, IEvent, INews, IProgress, IQuest, IUserProfile } from "./models";
import { Photo } from "./Photo";
import { RWebShare } from "react-web-share";
import { Event } from './Event';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm'
import { Loader } from "./Loader";
import { Stepper } from 'react-form-stepper';
import { TailSpin } from "react-loader-spinner";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";

const reprs = {
    "wait": <div className='flex gap-5'>
        <i className ="fa-solid fa-clock fa-2x text-[#01487C]"></i>
        <p>Ожидание проверки</p>
    </div>,
    "completed": <div className='flex gap-5'>
        <i className="fa-solid fa-thumbs-up fa-2x text-[#01487C]"></i>
        <p>Квест успешно выполнен. Вам начислено вознаграждение!</p>
    </div>,
    "error": <div className='flex gap-5'>
        <i className="fa-solid fa-triangle-exclamation fa-2x text-[#01487C]"></i>
        <p>Ошибка в выполнении квеста. Пожалуйста, проверьте правильность действий и повторите попытку</p>
    </div>
}

export const PageQuest = () => {
    const params = useParams();
    const navigate = useNavigate();
    const { db, user, analytics, storage } = useContext(FirebaseContext);
    const [ quest, setQuest ] = useState<IQuest | undefined>(undefined);
    const [ progresses, setProgresses ] = useState<IProgress[]>([]);
    const [ myProgress, setMyProgress ] = useState<IProgress | undefined>(undefined);
    const [ shared, setShared ] = useState(0);
    const [ loading, setLoading ] = useState(true);
    const [ activeStep, setActiveStep ] = useState(0);
    const fileRef = useRef<HTMLInputElement>(null);
    const [ fileWarn, setFileWarn ] = useState(false);
    const [ uploading, setUploading ] = useState(false);
    useEffect(() => {
        if (db) {
            return onSnapshot(doc(db, `/v2-quests/${params.id}`), (snapshot) => {
                if(snapshot.exists()){
                    const d = { ...snapshot.data(), id: snapshot.id } as IQuest;
                    setQuest(d);
                }
                else{
                    setQuest(undefined);
                }
                setLoading(false);
            });
        }
    }, [db, params.id]);
    useEffect(() => {
        if (db) {
            return onSnapshot(collection(db, 'v2-quests', params.id as string, 'shared'), (snapshot) => setShared(snapshot.docs.length));
        }
    }, [db, params.id]);
    useEffect(() => {
        if (db) {
            return onSnapshot(collection(db, 'v2-quests', params.id as string, 'ps'), (snapshot) => setProgresses(snapshot.docs.map((e) => { return { ...e.data(), id: e.id} as IProgress })));
        }
    }, [db, params.id]);
    useEffect(() => {
        if (db && user) {
            return onSnapshot(doc(db, 'v2-quests', params.id as string, 'ps', user.uid as string), (snapshot) => setMyProgress({ ...snapshot.data(), id: snapshot.id } as IProgress));
        }
    }, [db, params.id, user]);
    return <div className="padding-x py-10">
        <Loader loading={loading} />
        { quest ? 
        <div className="flex gap-10 flex-wrap justify-center">
            <input type='file' accept=".jpg, .jpeg, .png, .gif" ref={fileRef} onChange={(e) => {
                console.log('upload')
                if(user && e.target.files && e.target.files?.length > 0){
                    if(e.target.files[0].size < 5 * 1024 * 1024){
                        console.log('upload');
                        const name = `v2/images/screenshots/${user.uid}-${Date.now()}`;
                        const reff = ref(storage!, name);
                        setUploading(true);
                        uploadBytes(reff, e.target.files[0]).then((snapshot) => {
                            console.log('Uploaded a blob or file!');
                            getDownloadURL(reff).then((s) => {
                                setDoc(doc(db!, 'v2-quests', params.id as string, 'ps', user.uid as string), {
                                    status: 'wait',
                                    screenshot: name
                                }).then(() => setUploading(false));
                            })
                        });
                    }
                    else{
                        setFileWarn(true);
                    }
                }
            }} className="hidden"/>
            <div className="mb-10">
                <Photo src={quest.image!} alt={quest.title} size='large' variant="square" />
                <div className="flex gap-10 justify-center mt-10">
                    <div className="flex gap-5">
                        <p className='text-gray-500 text-lg'>{progresses.length}</p>
                        <i className="fa-solid fa-square-check fa-2x text-[#01487C]"></i>
                    </div>
                    <div className="flex gap-5">
                        <p className='text-gray-500 text-lg'>{shared}</p>
                        <RWebShare
                            data={{
                                text: `Квест "${quest.title}"`,
                                url: document.URL,
                                title: "Дорогой Добра"
                            }}
                            onClick={() => {
                                logEvent(analytics!, 'share', {
                                    content_type: 'quest',
                                    content_id: params.id,
                                });
                                if(user)
                                    setDoc(doc(db!, 'v2-quests', params.id as string, 'shared', user?.uid), {
                                        date: Timestamp.now()
                                    });
                            }}
                        >
                            <i className="fa-solid fa-share fa-2x text-[#01487C] cursor-pointer"></i>
                        </RWebShare>
                    </div>
                </div>
            </div>
            <div className='max-w-xl'>
                { quest.date ? <p className="text-lg text-gray-500">{moment(quest.date.toMillis()).fromNow()}</p> : null }
                { quest.experience ? <p className="text-lg text-gray-500">+ {quest.experience} очков опыта</p> : null }
                { quest.title ? <p className="text-4xl mt-3">{quest.title}</p> : null }
                { quest.description ? <div className="mt-7 appear space-y-5"><ReactMarkdown remarkPlugins={[remarkGfm]}>{quest.description}</ReactMarkdown></div> : null }
                { quest.steps ? <div className="mt-7">
                    <p className="text-3xl">Выполнение</p>
                    <Stepper
                        steps={quest.steps.map((v) => { return {label: v.title ? v.title : ''} })}
                        activeStep={activeStep}
                        connectorStateColors={false}
                        styleConfig={{
                            activeBgColor: '#01487C',
                            activeTextColor: '#fff',
                            borderRadius: '50%',
                            circleFontSize: '1rem',
                            completedBgColor: '#002d4d',
                            completedTextColor: '#fff',
                            fontWeight: 500,
                            inactiveBgColor: '#e0e0e0',
                            inactiveTextColor: '#fff',
                            labelFontSize: '#e0e0e0',
                            size: '2em'
                        }}
                    /> 
                    { quest.steps[activeStep] ? <div>
                        { quest.steps[activeStep].description ? <ReactMarkdown remarkPlugins={[remarkGfm]}>{quest.steps[activeStep].description!}</ReactMarkdown> : null }
                    </div> : null}
                    <div className="my-7"> 
                        <Button label="Предыдущий шаг" onClick={() => setActiveStep(activeStep - 1 >= 0 ? activeStep - 1 : 0)}/>
                        { activeStep >= quest.steps.length - 1 ? <div className="flex justify-center my-5">
                                {fileWarn ? <p>Размер файла превышает 5 мб</p> : null}
                                { user ? <div>
                                        { myProgress && progresses.find((v) => v.id === user.uid) && myProgress.status !== 'error' ? <div className="flex gap-5">
                                            <i className="fa-solid fa-check text-[#01487C] fa-2x"></i>
                                            <p>Вы уже прошли квест. Смотрите свой статус в поле "Сводка выполнения".</p>
                                        </div>
                                        :
                                        <div>
                                            {uploading ? 
                                                <TailSpin color="#01487C" height={80} width={80} /> :
                                                <Button label="Прикрепить и завершить квест" onClick={() => fileRef.current?.click()}/>
                                            }
                                        </div>
                                        } 
                                    </div>
                                    : <div>
                                        <p>Войдите в аккаунт, чтобы прикрепить файл</p>
                                        <Button label="Войти в аккаунт" onClick={() => navigate('/me')} />
                                    </div>
                                }
                            </div>
                            : <Button label="Следующий шаг" onClick={() => setActiveStep(Math.abs((activeStep + 1) % quest.steps!.length))}/>
                        }
                    </div>
                    {
                        myProgress && user && progresses.find((v) => v.id === user.uid) ? <div className="mt-10">
                            <p className="text-3xl">Сводка выполнения</p>
                            <div className="my-5">{ reprs[myProgress.status] }</div>
                            { myProgress.screenshot ? <div>
                                <p className="text-xl">Скриншот</p>
                                <Photo src={myProgress.screenshot} />
                            </div> : null}
                        </div> : null
                    }
                </div>: null }
            </div>
        </div>
        : <div className='flex justify-center gap-10 flex-wrap'>
            <div>
                <i className="fa-solid fa-map fa-7x text-[#01487C]"></i>
            </div>
            <div className="flex flex-col justify-center">
                <p className="text-3xl">Вы нашли инопланетный квест</p>
                <p className="text-xl mb-10">Квест удален или не существует</p>
                <Button label="На главную" onClick={() => navigate('/')} />
            </div>
        </div> }
    </div>
}

function setUploading(arg0: boolean) {
    throw new Error("Function not implemented.");
}
